// extracted by mini-css-extract-plugin
module.exports = {"headerLinksResponsiveContainer":"styles_headerLinksResponsiveContainer__cA4QW","burger":"styles_burger__SkM4p","open":"styles_open__WyDYQ"};